<template>
    <div class="about">
        <Inbanner :name="bannerName"/>
        <div class="container">
            <el-breadcrumb separator="/" style="margin:20px 0;">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>新闻</el-breadcrumb-item>
                <el-breadcrumb-item>{{newstitle}}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-card class="box-card news-card">
                <div slot="header" class="clearfix">
                    <h3 class="text-center">{{newstitle}}</h3>
                    <div class="text-center">
                        <span class="" style="margin-right:50px;"><i class="iconfont">&#xe9bd;</i> 仁迅科技</span> 
                        <span class=""><i class="iconfont">&#xe9a9;</i> {{newstime}}</span> 
                    </div>
                </div>
                <div class="news-content">
                    <span v-html="content"></span>
                </div>
            </el-card>
        </div>
    </div>
</template>
<script>
import Inbanner from './pages/Inbanner'
import { getNewDetail } from '@/api/news';
export default{
    data() {
        return {
            newstitle: 'iTrial Genies v3.0正式上线',
            newstime: '2021.10.16',
            content: "",
            bannerName: ''
        };
    },
    components:{
        Inbanner
    },
    created() {
      this.getDetail();
    },
    methods: {
        getDetail(){
            getNewDetail(this.getUrlParam('id')).then(res =>{
                this.newstitle = res.data.title
                let newDate = new Date(res.data.publishTime);
                var year = newDate.getFullYear(); //得到年份
                var month = newDate.getMonth(); //得到月份
                var date = newDate.getDate(); //得到日期
                month = month + 1;
                if (month < 10) month = "0" + month;
                if (date < 10) date = "0" + date;
                this.newstime = year + "-" + month + "-" + date; //（格式化"yyyy-MM-dd"
                this.content = res.data.content
                 if(res.data.category == 1) {
                    this.bannerName = "公司新闻"
                }else if(res.data.category == 2) {
                    this.bannerName = "行业新闻"
                }
            })
        },
        getUrlParam(name) {
            let url = window.location.hash.split('#')[1].split('?')[1].split('&')
            for(var i=0;i<url.length;i++){         //遍历数组，拿到json对象
                if(url[i].split('=')[0] == name){
                    return url[i].split('=')[1]
                }
            }
            return null
        }
    }
}
</script>
<style>
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
h2 {
    font-size: 22px;
    margin: 30px 0;
    font-weight: 700;
}
.news-content img{
    max-width:100%;
}
.news-content p{
    text-indent:2em;
    font-size:14px;
    margin-bottom: 20px;
}
.news-content ol li{
    list-style: square;
    margin-left: 30px;
}
.news-content ol li p{
    text-indent:0em;
    
}
</style>